import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const CollisionLiability = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="CollisionLiability" />
                    <HerosectionsAll ScreenName="Collision Liability" ScreenSearch="InsurableInterest" />

                    <div className="row col-lg-11 mx-auto p-2 p-lg-5 my-5">

                        <div className="col-12 p-lg-5 p-4 faint " style={{ textAlign: 'justify', }}>
                            <h5 className="fw-bold gray_color pb-3">Collision Liability</h5>

                            {/* <p>Transit Insurance policies are issued covering “All Risks” i.e. Institute Cargo Clauses (A) or against the Named Perils i.e. Institute Cargo Clauses (B) or Institute Cargo Clauses (C).  Claim under the policy will be governed by cover and exclusions of these clauses in addition to the other conditions and warranties (Express & Implied) of the said insurance contract. Relation between the Marine Insurance Act 1906 (MIA) (as amended 2015) and the policy of insurance is shown in the following diagram.   </p> */}
                            <div className="bg-white mt-3">
                                <img src="Static/Assets/Img/services/Claim Consultancy-01.png" alt="" className="Hull_claims_img" />
                            </div>
                            {/* <p className="pt-5">We assist our clients in the interpretation of the policy contract wordings and application of the same to the submitted claims. We assist in the over all claim management by handling claim documentation, claim communication, presentation of the claim to the concern authorities and advise on the protection of the recovery rights of the underwriters.</p> */}
                        </div>

                        <div className="col-12 p-lg-5 p-4 mt-5 faint " style={{ textAlign: 'justify', }}>
                            <div className="bg-white mt-3">
                                <img src="Static/Assets/Img/services/Claim Consultancy-02.png" alt="" className="Hull_claims_img" />
                            </div>
                        </div>

                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
